import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { map, catchError } from 'rxjs/operators';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var BpgAdminServices = /** @class */ (function () {
    function BpgAdminServices(http, 
    //private logger: BPGLoggerService,
    bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.adminListApi = ConstantValues.userManagementApiUrl.adminList;
        this.URI = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.adminDeleteApi = ConstantValues.userManagementApiUrl.deleteAdmin;
        this.adminSaveApi = ConstantValues.userManagementApiUrl.saveAdmin;
        this.chapterAdminListApi = ConstantValues.userManagementApiUrl.chapterAdminList;
        this.chapterAdminSaveApi = ConstantValues.userManagementApiUrl.saveChapterAdmin;
        this.deleteChapterAdminApi = ConstantValues.userManagementApiUrl.deleteChapterAdmin;
        this.updateEmailApi = ConstantValues.userManagementApiUrl.updateEmail;
        this.naacadminSaveApi = ConstantValues.userManagementApiUrl.savenaacAdmin;
        this.naacadminListApi = ConstantValues.userManagementApiUrl.naacadminList;
        this.naacadminDeleteApi = ConstantValues.userManagementApiUrl.deletenaacAdmin;
        this.updateMembershipEmailApi = ConstantValues.userManagementApiUrl.saveMembershipUserEmail;
    }
    /** For service call to GET all admins
     * @class BpgAdminServices
     * @method getAllAdmins
     * @param landingData
     * @returns Observable
     */
    BpgAdminServices.prototype.getAllAdmins = function (landingData) {
        return this.http.post(this.URI + this.adminListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin list failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET all Naac admins
   * @class BpgAdminServices
   * @method getAllNaacAdmins
   * @param landingData
   * @returns Observable
   */
    BpgAdminServices.prototype.getAllNaacAdmins = function (landingData) {
        return this.http.post(this.URI + this.naacadminListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin list failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete ADMIN
    * @class BpgAdminServices
    * @method deleteAdmin
    * @param landingData
    * @returns Observable
    */
    BpgAdminServices.prototype.deleteAdmin = function (id) {
        return this.http.delete(this.URI + this.adminDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin delete failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete NAAC ADMIN
  * @class BpgAdminServices
  * @method deletenaacAdmin
  * @param landingData
  * @returns Observable
  */
    BpgAdminServices.prototype.deleteNaacAdmin = function (id) {
        return this.http.delete(this.URI + this.naacadminDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin delete failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to SAVE ADMIN
  * @class BpgAdminServices
  * @method saveAdmin
  * @param landingData
  * @returns Observable
  */
    BpgAdminServices.prototype.saveAdmin = function (landingData) {
        return this.http.post(this.URI + this.adminSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin save failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to SAVE NNAC ADMIN
* @class BpgAdminServices
* @method saveNaacAdmin
* @param landingData
* @returns Observable
*/
    BpgAdminServices.prototype.saveNaacAdmin = function (landingData) {
        return this.http.post(this.URI + this.naacadminSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin save failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Update EMAIL
      * @class BpgAdminServices
      * @method updateEmail
      * @param landingData
      * @returns Observable
      */
    BpgAdminServices.prototype.updateEmail = function (landingData) {
        console.log(landingData);
        return this.http.post(this.URI + this.updateEmailApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            console.log(data);
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin delete failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Update EMAIL from membership screen
      * @class BpgAdminServices
      * @method updateEmail
      * @param landingData
      * @returns Observable
      */
    BpgAdminServices.prototype.updateMembershipEmail = function (landingData) {
        console.log(landingData);
        return this.http.post(this.URI + this.updateMembershipEmailApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            console.log(data);
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin delete failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET all chapter admins
     * @class BpgAdminServices
     * @method getAllChapterAdmins
     * @param landingData
     * @returns Observable
     */
    BpgAdminServices.prototype.getAllChapterAdmins = function (landingData) {
        return this.http.post(this.URI + this.chapterAdminListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin list failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to SAVE ADMIN
  * @class BpgAdminServices
  * @method saveAdmin
  * @param landingData
  * @returns Observable
  */
    BpgAdminServices.prototype.saveChapterAdmin = function (landingData) {
        return this.http.post(this.URI + this.chapterAdminSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin save failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete Chapter ADMIN
     * @class BpgAdminServices
     * @method deleteChapterAdmin
     * @param landingData
     * @returns Observable
     */
    BpgAdminServices.prototype.deleteChapterAdmin = function (landingData) {
        return this.http.post(this.URI + this.deleteChapterAdminApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.adminModule, '', 'Getting admin delete failed in admin.component.ts', '', error);
            throw of(error);
        }));
    };
    BpgAdminServices.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function BpgAdminServices_Factory() { return new BpgAdminServices(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: BpgAdminServices, providedIn: "root" });
    return BpgAdminServices;
}());
export { BpgAdminServices };
